module.exports = __webpack_public_path__ + "img/i.87256c99.jpg";